
// 29-10
import React, { useState, useEffect, useContext, useRef } from "react";
import AdminContext from "../../StateContext/Application";
import {
 True32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
  SendBack32,
  DeleteRed32,
  Approved32,
  EditViewEmp,
  PDF32,
  Excel32,
  JPG32,
  PNG32,
  UpdateWhite32,
} from "../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../path";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import DemandGeneration from "../DemandManagement/DemandGeneration/DemandGeneration";
import { useNavigate } from "react-router-dom";
// 19-10 file type icon
const getFileIcon = (fileName) => {
  const ext = (fileName || "").split(".").pop().toLowerCase();
  if (ext === "pdf") return PDF32;
  if (ext === "xls" || ext === "xlsx") return Excel32;
  if (ext === "jpg" || ext === "jpeg") return JPG32;
  if (ext === "png") return PNG32;
  return UpdateWhite32; // default icon
};

//29/10
const numberToWords = (num) => {
  const number = Math.floor(Number(num));

  if (!Number.isFinite(number) || number < 0) return "-";
  if (number === 0) return "Zero Rupees Only";

  const ones = [
    "", "One", "Two", "Three", "Four", "Five", "Six",
    "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
    "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen",
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety",
  ];

  const convert = (n) => {
    if (n < 20) return ones[n];
    if (n < 100) {
      return `${tens[Math.floor(n / 10)]} ${ones[n % 10]}`.trim();
    }
    if (n < 1000) {
      return `${ones[Math.floor(n / 100)]} Hundred ${
        convert(n % 100)
      }`.trim();
    }
    if (n < 100000) {
      return `${convert(Math.floor(n / 1000))} Thousand ${
        convert(n % 1000)
      }`.trim();
    }
    if (n < 10000000) {
      return `${convert(Math.floor(n / 100000))} Lakh ${
        convert(n % 100000)
      }`.trim();
    }

    return `${convert(Math.floor(n / 10000000))} Crore ${
      convert(n % 10000000)
    }`.trim();
  };

  return `${convert(number)} Rupees Only`;
};

//29/10
const formatSlipDate = (v) => {
  if (!v) return "-";
  const d = new Date(v);
  if (isNaN(d.getTime())) return "-";
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};
const BillApprovals = () => {
  const context = useContext(AdminContext);
  const {
    GetDemandApproval,
    GetBills,
    ApproveBills,
    GetVendorBillsAndDeduction,
    GetBudgetHeadInfo,
    GetTotalAmountAvailbaleInBank,
    Usermenu,
  } = context; // Ensure ApproveBills is defined in your context
  const [bills, setBills] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 4; // Show 4 bills per page
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [filteredBills2, setFilteredBills2] = useState([]);
  const [
    fetchSpecificDemandDeductionDetail,
    setfetchSpecficDemandDeductionDetail,
  ] = useState([]);
  const [showspecific, setShowSpecific] = useState(0);
  const [selectedDemandID, setSelectedDemandID] = useState(null);
  const [selectedBillData, setselectedBillData] = useState(null);
  const [exportingBillSlipPDF, setExportingBillSlipPDF] = useState(false);
  const [exportingPDF, setExportingPDF] = useState(false);
  const [getAvailableBankBalance, SetAvailableBankBalance] = useState([]);
  const [BankBalance, setBankBalance] = useState([]);
  const billSlipRef = useRef(null);

  const [remark, setRemark] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editBillData, setEditBillData] = useState(null);
  console.log("Edit Bill Data:", editBillData);
  const [menuData, setMenuData] = useState(null);

  

  // 10-10 sort
    const getbills = async () => {
    try {
      let data = await GetDemandApproval();
      console.log("Bills from API:", data);
           if (Array.isArray(data)) {
        // Latest entry first
        const sortedData = [...data].sort((a, b) =>
          String(b.DemandGenerationID ?? "").localeCompare(
            String(a.DemandGenerationID ?? ""),
            undefined,
            { numeric: true }
          )
        );
        setBills(sortedData);
        setFilteredBills(sortedData);
      } else {
        setBills([]);
        setFilteredBills([]);
      }
    } catch (error) {
      console.log("Get bills error:", error);
      setBills([]);
      setFilteredBills([]);
    }
  };
 




  const navigate = useNavigate();
  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      setMenuData(res.Data);
    };

    getMenu();
  }, []);

  const isMaker =
    menuData?.Department_Name === "New Agency Maker" &&
    menuData?.Role === "New Agency Maker";
  const isChecker =
    (menuData?.Department_Name === "State Checker" ||
      menuData?.Department_Name === "New Agency Checker" ||
      menuData?.Department_Name === "Agency Checker" ||
      menuData?.Department_Name === "Agency Maker" ||
      menuData?.Department_Name === "State Maker" ||
      menuData?.Department_Name === "State Admin") &&
    (menuData?.Role === "State Checker" ||
      menuData?.Role === "New Agency Checker" ||
      menuData?.Role === "Agency Checker" ||
      menuData?.Role === "Agency Maker" ||
      menuData?.Role === "State Maker" ||
      menuData?.Role === "State Admin");

  const isStateMaker =
    menuData?.Department_Name === "State Maker" &&
    menuData?.Role === "State Maker";

  useEffect(() => {
    console.log("bill length:", bills.length);
    console.log("bill data:", bills);
    getbills();
  }, []);

  useEffect(() => {
    getbills();
    GetTotalAmountAvailableInBank();
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(
    filteredBills
      ? filteredBills.length / billsPerPage
      : bills.length / billsPerPage,
  );

  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills
    ? filteredBills.slice(indexOfFirstBill, indexOfLastBill)
    : bills.slice(indexOfFirstBill, indexOfLastBill);

  // Handle individual checkbox selection
  const handleCheckboxChange = (id) => {
    setSelectedBills(
      (prevSelected) =>
        prevSelected.includes(id)
          ? prevSelected.filter((billId) => billId !== id) // Remove if already selected
          : [...prevSelected, id], // Add if not selected
    );
  };

  // Handle "Select All" checkbox
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(filteredBills.map((bill) => bill.DemandGenerationID));
    } else {
      setSelectedBills([]);
    }
  };
  
  // Send selected bills to backend for approval
  const approveSelected = async (type, remark) => {
    if (selectedBills.length === 0) {
      alert("No bills selected for approval!");
      return;
    }
    // const selectedBillData = bills.filter(bill =>
    //     selectedBills.includes(bill.DemandGenerationID)
    // );
    const selectedBillData = Array.isArray(bills)
      ? bills.filter((bill) => selectedBills.includes(bill.DemandGenerationID))
      : [];
    const totalApprovalAmount = selectedBillData.reduce(
      (sum, bill) => sum + Number(bill.NetPayableAmount || 0),
      0,
    );
    const availableBalance = Number(BankBalance?.AvailableBalanceinBank || 0);

    // if (totalApprovalAmount > availableBalance) {
    //     alert(`Insufficient Bank Balance.\nAvailable Balance: ₹${availableBalance}\nSelected Bill Amount: ₹${totalApprovalAmount}`);
    //     return;
    // }
    // if (isStateMaker && totalApprovalAmount > availableBalance) { 
    // 23-09
    if (
  type !== "SendBack" &&
  type !== "Rejected" &&
  isStateMaker &&
  totalApprovalAmount > availableBalance
) {
      alert(
        `Insufficient Bank Balance.\nAvailable Balance: ₹${availableBalance}\nSelected Bill Amount: ₹${totalApprovalAmount}`,
      );
      return;
    }
    const confirmAction = window.confirm(
      `Are you sure you want to ${type} selected bills?`,
    );
    if (!confirmAction) {
      alert(`Bill ${type} operation cancelled.`);
      setRemark("");
      setRejectpanelhide(0);
      return;
    }
    setLoading(true); // Start loader
    try {
      const response = await ApproveBills(selectedBills, type, remark);
      if (response.message) {
        alert(response.message);
        getbills();
        setRejectpanelhide(0);
        setRemark("");
        window.location.reload();
      } else if (response.error) {
        alert(response.error);
        getbills();
        setRejectpanelhide(0);
        setRemark("");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error approving bills:", error);
      alert("An error occurred while approving bills.");
      setRejectpanelhide(0);
      setRemark("");
      window.location.reload();
    } finally {
      setLoading(false);
    } // Stop loader
  };
  const GetTotalAmountAvailableInBank = async () => {
    let data = await GetTotalAmountAvailbaleInBank();
    console.log("availablebalance-----", data);
    setBankBalance(data.result[0]);
    // setCountBalance(data.result1[0])
  };

  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = bills.filter((bill) =>
      Object.values(bill).some((bill) =>
        (bill || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1); // Reset to page 1 on search
  }, [searchTerm, bills]);

  const getDemandGenerationListForbillPDF = async (demandId = null) => {
    try {
      const idToUse = demandId || selectedDemandID;
      let data1 = await GetBudgetHeadInfo(
        "null",
        "GetDemandGenerationListForbillPDF",
        idToUse,
      );
      console.log("dataForbillPDF ------------", data1);
      setFilteredBills2(data1);
      return data1;
    } catch (err) {
      console.log("Error in getDemandGenerationListForbillPDF:", err);
      return [];
    }
  };
  const settingshowspecific3 = async (DemandID) => {
    try {
      let res = await GetVendorBillsAndDeduction(DemandID);
      console.log("GetVendorBillsAndDeduction", res);

      setfetchSpecficDemandDeductionDetail(res);
      setSelectedDemandID(DemandID);

      const billsForPDF = await getDemandGenerationListForbillPDF(DemandID);
      setShowSpecific(3);

      const filtered = Array.isArray(billsForPDF)
        ? billsForPDF.filter((val) => val.DemandGenerationID == DemandID)
        : [];
      console.log("filtered", filtered);

      setselectedBillData(filtered[0] || null);
    } catch (err) {
      console.log(err);
    }
  };
  const exportBillSlipPDF = async () => {
    if (!billSlipRef.current) {
      alert("Bill slip not found");
      return;
    }

    setExportingBillSlipPDF(true);

    try {
      const canvas = await html2canvas(billSlipRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const margin = 5;

      const maxImgWidth = pageWidth - margin * 2;
      const maxImgHeight = pageHeight - margin * 2;

      const widthRatio = maxImgWidth / canvas.width;
      const heightRatio = maxImgHeight / canvas.height;

      const ratio = Math.min(widthRatio, heightRatio);

      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      pdf.addImage(
        canvas.toDataURL("image/png"),
        "PNG",
        (pageWidth - imgWidth) / 2,
        margin,
        imgWidth,
        imgHeight,
      );

      const transactionNo = selectedBillData?.TransactionNo || selectedDemandID;

      pdf.save(`Bill_Slip_${transactionNo || "MMGSY"}.pdf`);
    } catch (error) {
      console.error("Bill slip PDF export error:", error);

      alert("Failed to export bill slip PDF.");
    } finally {
      setExportingBillSlipPDF(false);
    }
  };
  const BackFunction = () => {
    setfetchSpecficDemandDeductionDetail([]);
    setselectedBillData({});
    setSelectedDemandID(null);
    setShowSpecific(0);
  };
  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No bill Selected !!!");
    }
  };
  console.log("Parent billData:", bills);

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // First pages
    if (currentPage <= 3) {
      pages.push(1, 2, 3, 4, 5);
      pages.push("...");
      pages.push(totalPages);

      return pages;
    }

    // Last pages
    if (currentPage >= totalPages - 2) {
      pages.push("...");

      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }

      return pages;
    }

    // Middle pages
    pages.push("...");

    pages.push(
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
    );

    pages.push("...");
    pages.push(totalPages);

    return pages;
  };


 
const row = fetchSpecificDemandDeductionDetail[0];

const signatureData = [];
signatureData.push({
  FullName: row?.CreatedByName || "",
  designation: "New Agency Maker",
  label: "Created Date",
  date: row?.UploadedOn ? row.UploadedOn.split("T")[0] : "-",
});

if (row?.Approval1 === "true") {
  signatureData.push({
    FullName: row?.Approval1ByName || "",
    designation: "New Agency Checker",
    label: "Approved Date",
    date: row?.Approval1Date ? row.Approval1Date.split("T")[0] : "-",
  });
}

if (row?.Approval2 === "true") {
  signatureData.push({
    FullName: row?.Approval2ByName || "",
    designation: "Agency Maker",
    label: "Approved Date",
    date: row?.Approval2Date ? row.Approval2Date.split("T")[0] : "-",
  });
}

if (row?.Approval3 === "true") {
  signatureData.push({
    FullName: row?.Approval3ByName || "",
    designation: "Agency Checker",
    label: "Approved Date",
    date: row?.Approval3Date ? row.Approval3Date.split("T")[0] : "-",
  });
}

if (row?.Approval4 === "true") {
  signatureData.push({
    FullName: row?.Approval4ByName || "",
    designation: "State Maker",
    label: "Approved Date",
    date: row?.Approval4Date ? row.Approval4Date.split("T")[0] : "-",
  });
}

if (row?.Approval5 === "true") {
  signatureData.push({
    FullName: row?.Approval5ByName || "",
    designation: "State Checker",
    label: "Approved Date",
    date: row?.Approval5Date ? row.Approval5Date.split("T")[0] : "-",
  });
}

//29/10
const getPrintDate = () => {
  return new Date().toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

  return (
    <>
    {/* //29/10 */}
      <style>{`
  .bs-grid {
    width: 100%;
    border-collapse: collapse !important;
    border-spacing: 0 !important;
    border: 1px solid #333 !important;
  }

  .bs-grid th,
  .bs-grid td {
    border: 1px solid #333 !important;
    padding: 6px 8px !important;
    vertical-align: middle;
    box-sizing: border-box;
  }

  .bs-grid tr {
    border: 1px solid #333 !important;
  }

  .bs-grid th {
    text-align: center;
  }
  .bs-table-wrapper {
  margin-bottom: 12px;
}

.bs-table-wrapper:last-child {
  margin-bottom: 0;
}  
`}</style>

      
            {!showEditForm ? (
              <>
              {/* //30/10 */}
             
              <div
            style={
              showspecific === 0
                ? {
                    background: "#EEF2F7",
                    border: "1px solid #dfe5ee",
                    borderRadius: "10px",
                    margin: "15px 20px",
                    padding: "0px 20px 20px",
                    boxSizing: "border-box",
                  }
                : { padding: "0px 20px 0", boxSizing: "border-box" }
            }
          >
            {/* //30/10 */}
      {showspecific === 0 && (
                <div
                  style={{
          width: "100%",
          marginTop: "30px",
          marginBottom:"20px",
          padding: "0 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          boxSizing: "border-box",
        }}
       
                >
                  {/* <div
                  // 26-09
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      // background: "linear-gradient(100deg, #d7e5f5, #e9effc)",
      
                      padding: "12px 0",
      
                      //     width:'auto',
                      //    maxWidth:'1500px',
                      // width: "auto",
                      // marginRight: "20px",
                      // marginLeft: "-30px",
                      marginBottom: "20px",
                      paddingRight: "80px",
                    }}
                  >
                     */}
                    <h4
                      className="text-center fw-bold"
                      // 26-09
                      style={{
            margin: 0,
            padding: 0,
            fontWeight: "bold",
            color: "black",
            display: "flex",
            alignItems: "center",
            whiteSpace: "nowrap",
          }}
       
                    ><img
          src="/Bill-Approval-List-32.png"
          alt="img"
         style={{height:"28px", width:"28px", marginRight:"10px"}}
        />
                      Bill Approval List
                    </h4>
                      <div  style={{
          position: "relative",
          width: "245px",
        }} >
           <img
          src="/Search-32.png"
          alt="Search"
          style={{
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            width: "18px",
            height: "18px",
            zIndex: 1,
          }}
        />
       
                                <input
                                  type="text"
                                  placeholder="Search"
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  value={searchTerm}
                                   style={{
            width: "100%",
            height: "34px",
            padding: "6px 10px 6px 36px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            boxSizing: "border-box",
            margin: 0,
          }}
       
                                />
                              </div>
                                </div>
      )}
      
                  {/* </div> */}
                  {showspecific === 0 && (
                    //26/10
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        width: "100%",
                        maxWidth: "1000px", 
                        margin: "0 auto",
                        borderRadius: "5px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        padding: "20px 20px", 
                        // minHeight: "81vh",
                        // overflow: "auto",
                      }}
                    >
                      {/* Separate "Select All Files" checkbox */}
                      {/* {bills.length === 0 && (
                        <h4
                          style={{
                            backgroundColor: "#324e77",
                            padding: "8px",
                            color: "white",
                            textAlign: "center",
                            margin: "8px",
                          }}
                        >
                          No Bills For Approvals
                        </h4>
                      )} */}
                      <div>
                        {/* {bills.length > 0 && ( */}
                        <div>
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                // padding: "0px 0rem",
                              }}
                            >
                              <th
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  // paddingRight: "20px",
                                }}
                              >
                                {/* <input
                                              type="checkbox"
                                              onChange={handleSelectAll}
                                              checked={selectedBills.length === filteredBills.length && filteredBills.length > 0}
                                              style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
                                          />
                                          <label >Select All Files</label> */}
                                {/* <label className="mx-5">
                                  Files Selected : {selectedBills.length}
                                </label> */}
                              </th>
      
                              {/* Filter Dropdown */}
                              {/* <div style={{ margin: '8px' }}>
                              <label style={{ fontWeight: 'bold', marginRight: '8px' }}>Filter by Amount Type:</label>
                              <select onChange={(e) => setFilter(e.target.value)} value={filter}>
                                  <option value=''>All</option>
                                  <option value='Total Amount Payable'>Total Amount Payable</option>
                                  <option value='GST'>GST</option>
                                  <option value='TDS'>TDS</option>
                              </select>
                          </div> */}
                            
                            </div>
                            <div className="DemandElement m-auto">
                              <div className="col-12">
                                <div className="row">
                                  <div style={{ position: "relative", width: "100%",  minHeight: (!Array.isArray(currentBills) || currentBills.length === 0) ? "150px" : "auto",}}>
                                 {/* //28/10 */}
                                 <div
        style={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "auto",
          overflowY: "hidden",
          boxSizing: "border-box",
          borderRadius: "8px",
          border: "1px solid #d9e1f2",             
          boxShadow: "0 2px 8px rgba(0,0,0,0.10)",  
          background: "#ffffff",
        }}
      >
      
                                  
                                    <table 
        style={{
          backgroundColor: "white",
          // width: "1600px",
          minWidth: "1600px",
          tableLayout: "fixed",
          borderCollapse: "separate",  
          borderSpacing: 0,             
          fontFamily: "Inter, sans-serif",
          fontSize: "11px",
        
        }}
      >
             <colgroup>
          <col style={{ width: "50px" }} />   {/* checkbox */}
          <col style={{ width: "60px" }} />   {/* Sr. No. */}
          {isMaker && <col style={{ width: "60px" }} />}  {/* Action */}
        </colgroup>
                                      <thead>
                                        {/* {currentBills.length > 0 && ( */}
      
                                        {/* //28/10 */}
                                          <tr
                                            style={{
                                              backgroundColor: "#2D79D9",
                                              color: "white",
                                              fontSize: "14px",
                                              fontWeight: 600,
                                              textAlign: "center",
                                              whiteSpace: "nowrap",
                                              height: "42px",
                                              borderRadius: "8px",
                                            }}
                                          >
                                             {/* <th style={{ padding: "8px" }}>
                                              <input
                                                type="checkbox"
                                                onChange={handleSelectAll}
                                                checked={
                                                  selectedBills.length ===
                                                    filteredBills.length &&
                                                  filteredBills.length > 0
                                                }
                                                style={{
                                                  marginRight: "5px",
                                                  marginLeft: "10px",
                                                  height: "1.5rem",
                                                  width: "1.5rem",
                                                }}
                                              />
                                            </th>
                                            <th>Sr. No.</th> */}
                                            {/* 05-10 */}
                                            <th style={{ padding: "8px 4px", width: "50px", textAlign: "center" }}>
        <input
          type="checkbox"
          onChange={handleSelectAll}
          checked={
            selectedBills.length === filteredBills.length &&
            filteredBills.length > 0
          }
          style={{ margin: 0, height: "1.2rem", width: "1.2rem" }}
        />
      </th>
      <th style={{ padding: "8px 4px", width: "60px", textAlign: "center" }}>
        Sr. No.
      </th>
                                            {isMaker && (
                                              <th>
                                                Action
                                              </th>
                                            )}
                                           
                                            <th style={{ padding: "8px" }}>
                                              Project Name
                                            </th>
                                            <th style={{ padding: "8px" }}>
                                              Demand Number
                                            </th>
                                            {/* <th style={{ padding: "8px" }}>Budget Head Code</th> */}
                                            {/* <th style={{ padding: "8px" }}>CRC Code</th> */}
                                            {/* <th style={{ padding: "8px" }}>Bill Type</th> */}
                                            <th style={{ padding: "8px" }}>
                                              Bill Date
                                            </th>
                                            <th style={{ padding: "8px" }}>
                                              Bill Amount
                                            </th>
                                            <th style={{ padding: "8px" }}>
                                              Deduction
                                            </th>
                                            <th style={{ padding: "8px" }}>
                                              Contractor Name
                                            </th>
                                            <th style={{ padding: "8px" }}>
                                              Bill Copy
                                            </th>
                                            <th style={{ padding: "8px" }}>
                                              Work Order Copy
                                            </th>
                                            <th style={{ padding: "8px" }}>
                                              View MAS Slip
                                            </th>
                                            {isMaker && (
                                              <th style={{ padding: "10px" }}>
                                                Remark
                                              </th>
                                            )}
                                            {/* <th>General Manager Approval</th>
                                                                      <th>Account Approval</th>
                                                                      <th>Admin Approval</th> */}
                                          </tr>
                                        {/* )} */}
                                      </thead>
                                      {/* <tbody>
                                        {currentBills.length < 1 ? (
                                          <tr>
                                            <td
                                              style={{
                                                background:
                                                  "linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)",
                                                color: "black",
                                                height: "2.5rem",
                                                border: "none",
                                                display: "grid",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              No Bills For Approvals
                                            </td>
                                          </tr>
                                        ) : ( */}
                                        <tbody>
        {!Array.isArray(currentBills) || currentBills.length < 1 ? (
      <tr>
      {/* <td
              colSpan={isMaker ? 13 :11}
              style={{
                textAlign: "center",
                padding: "20px",
                backgroundColor: "#f9f9f9",
                color: "black",
              }}
      >
              No data available
      </td> */}
      </tr>
        ) : (
                                          currentBills.map((bill, index) => (
                                            <tr
                                              style={{
                                                height: "5rem",
                                                //28/10
                                                backgroundColor:
                                                  index % 2 === 0
                                                    ? "#E5F4FB"
                                                    : "#CEE4F1",
                                              }}
                                              key={bill.UniqueID}
                                            >
                                                {/* <td style={{ height: "2.5rem" }}>
                                                <input
                                                  type="checkbox"
                                                  style={{
                                                    marginLeft: "10px",
                                                    marginRight: "5px",
                                                    padding: "20px",
                                                    height: "1.5rem",
                                                    width: "1.5rem",
                                                  }}
                                                  checked={selectedBills.includes(
                                                    bill.DemandGenerationID,
                                                  )}
                                                  onChange={() =>
                                                    handleCheckboxChange(
                                                      bill.DemandGenerationID,
                                                    )
                                                  }
                                                />
                                              </td>
                                              <td>
                                                {(currentPage - 1) * billsPerPage +
                                                  index +
                                                  1}
                                              </td> */}
                                              <td style={{ height: "2.5rem", textAlign: "center", padding: "0 4px" }}>
        <input
          type="checkbox"
          style={{ margin: 0, height: "1.2rem", width: "1.2rem" }}
          checked={selectedBills.includes(bill.DemandGenerationID)}
          onChange={() => handleCheckboxChange(bill.DemandGenerationID)}
        />
      </td>
      <td style={{ textAlign: "center", padding: "0 4px" }}>
        {(currentPage - 1) * billsPerPage + index + 1}
      </td>
                                              {isMaker && (
                                                <td
                                                  style={{
                                                    padding: "10px",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <button
                                                    onClick={() => {
                                                      console.log(
                                                        "Selected bill For Edit:",
                                                        bill,
                                                      );
                                                      console.log(
                                                        "DeductionList:--->",
                                                        bill.DeductionList,
                                                      );
      
                                                      setEditBillData(bill);
                                                      setShowEditForm(true);
                                                    }}
                                                    style={{
                                                      border: "none",
                                                      background: "transparent",
                                                      cursor: "pointer",
                                                      color: "black",
                                                    }}
                                                    Edit
                                                  >
                                                    <img
                                                      src={EditIcon}
                                                      alt="Edit"
                                                      style={{
                                                        width: "20px",
                                                        height: "20px",
                                                      }}
                                                    />
                                                    Edit
                                                  </button>
                                                </td>
                                              )}
                                            
                                              {/* <td>{indexOfFirstBill + index + 1}</td> */}
                                              <td>{bill.ProjectName}</td>
                                              <td>{bill.DemandGenerationID}</td>
                                              {/* <td >{bill.BudgetID}</td> */}
                                              {/* <td >{bill.CRC}</td> */}
      
                                              {/* <td>--</td> */}
                                              <td>
                                                {new Date(bill.Date).toLocaleString()}
                                              </td>
                                              <td>
                                                {/* {bill.NetPayableAmount} */}
                                                {Number(
                                                  bill.NetPayableAmount || 0,
                                                ).toLocaleString("en-IN")}
                                              </td>
                                              <td>
                                                {/* {bill.DeductionAmount} */}
                                                {Number(
                                                  bill.DeductionAmount || 0,
                                                ).toLocaleString("en-IN")}
                                              </td>
                                              <td>{bill.ContractorName}</td>
                                                {/* 19-10 add icon  */}
                                              {/* <td style={{padding: "8px", minWidth: "220px", width: "220px", maxWidth: "220px",whiteSpace: "nowrap", textAlign: "center"}}>
                                                <p>
                                                  <a
                                                    href={`${apiurl}/BillCopyDocsImages/${bill.UploadBillCopy}`}
                                                    target="_blank"
                                                    title={bill.UploadBillCopy}   
                                                style={{ display: "flex", alignItems: "center",  justifyContent: "center",gap: "5px", width: "100%",overflow: "hidden",textDecoration: "none", color: "#0d6efd", }} >
                                                  
                                                    
                                                    {bill.DemandGenerationID} Bill Copy
                                                  </a>
                                                </p>
                                              </td> */}
      <td style={{padding: "8px", minWidth: "220px", width: "220px", maxWidth: "220px", whiteSpace: "nowrap", textAlign: "center"}}>
        {bill.UploadBillCopy ? (
          <a
            href={`${apiurl}/BillCopyDocsImages/${bill.UploadBillCopy}`}
            target="_blank"
            rel="noreferrer"
            title={bill.UploadBillCopy}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              width: "100%",
              overflow: "hidden",
              textDecoration: "none",
              color: "#0d6efd",
            }}
          >
            <img
              src={getFileIcon(bill.UploadBillCopy)}
              alt="file icon"
              style={{ width: "20px", height: "20px", flexShrink: 0 }}
            />
            {bill.DemandGenerationID} Bill Copy
          </a>
        ) : (
          <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
        )}
      </td>
      
                                              {/* <td style={{padding: "8px", minWidth: "200px", width: "200px", maxWidth: "200px",whiteSpace: "nowrap", textAlign: "center"}} >
                                                <p>
                                                  <a
                                                    href={`${apiurl}/WorkOrderDocsImages/${bill.CopyofWorkOrder}`}
                                                    target="_blank"
                                                    title={bill.CopyofWorkOrder}   
                                                style={{ display: "flex", alignItems: "center",  justifyContent: "center",gap: "5px", width: "100%",overflow: "hidden",textDecoration: "none", color: "#0d6efd", }} >
                                                  CopyWorkOrder
                                                  </a>
                                                </p>
                                              </td> */}
      <td style={{padding: "8px", minWidth: "200px", width: "200px", maxWidth: "200px", whiteSpace: "nowrap", textAlign: "center"}}>
        {bill.CopyofWorkOrder ? (
          <a
            href={`${apiurl}/WorkOrderDocsImages/${bill.CopyofWorkOrder}`}
            target="_blank"
            rel="noreferrer"
            title={bill.CopyofWorkOrder}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              width: "100%",
              overflow: "hidden",
              textDecoration: "none",
              color: "#0d6efd",
            }}
          >
            <img
              src={getFileIcon(bill.CopyofWorkOrder)}
              alt="file icon"
              style={{ width: "20px", height: "20px", flexShrink: 0 }}
            />
            Work Order Copy
          </a>
        ) : (
          <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
        )}
      </td>
                                              <td
                                                style={{
                                                  fontSize: "12px",
                                                  padding: "5px",
                                                }}
                                              >
                                                <button
                                                  className="btn py-1 d-flex align-items-center justify-content-center gap-2 mx-auto"
                                                   style={{
                                  minWidth: "47px",
                                  height: "24px",
                                  padding: "2px 7px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "4px",
                                  fontSize: "10px",
                                  fontWeight: "600",
                                  lineHeight: "1",
                                  cursor: "pointer",
                                  background: "#ffffff",
                                  color: "#39a852",
                                  border: "1px solid #39a852",
                                  borderRadius: "4px",
                                  boxShadow: "none",
                                }}
                                                  onClick={() =>
                                                    settingshowspecific3(
                                                      bill.DemandGenerationID,
                                                    )
                                                  }
                                                >
                                                  <img
                                                    // src={EditViewEmp}
                                                    // alt="View"
                                                    // width="18"
                                                    // height="18"
                                                    // style={{
                                                    //   objectFit: "contain",
                                                    //   display: "block",
                                                    // }}
                                                    src="/View-32.png"
                                  alt="view"
                                  width="15"
                                  height="15"
                                                  />
                                                  <span>View</span>
                                                </button>
                                              </td>
                                              {isMaker && (
                                                <td style={{ padding: "10px" }}>
                                                  {bill.Remark}
                                                </td>
                                              )}
                                              {/* <td>{bill.General_Manager_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
                                      <td>{bill.Account_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
                                      <td>{bill.Admin_Approval === 'true' ? 'Approved' : 'Not Approved'}</td> */}
                                            </tr>
                                          ))
                                        )}
                                      </tbody>
                                    </table>
      {/* 24-09 no data found msg */}
      
                                      {(!Array.isArray(currentBills) || currentBills.length === 0) && (
        <div
          style={{
            position: "sticky",
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px",
            boxSizing: "border-box",
            backgroundColor: "#f9f9f9",
            color: "black",
            fontSize: "14px",
            fontWeight: 500,
            border: "1px solid #d9d9d9",
            borderTop: "none",
          }}
        >
          No data available
        </div>
      )}
      
      {/* ---- */}
                                  </div>
                                </div>
                                </div>
                              </div>
                            </div>
      
                            {/* Pagination Controls */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                width: "100%",
                                gap: "10px",
                              }}
                            >
                              {/* Approve */}
                              <button
                                onClick={() => approveSelected("Approved", "")}
                                disabled={loading}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "8px",
                                  margin: "12px 0",
                                  padding: "8px 20px",
                                  backgroundColor:
                                    selectedBills.length <= 0 ? "#f3eeee" : "#39B54A",
                                  color:
                                    selectedBills.length > 0 ? "#ffffff" : "#01B574",
                                  border: "1px solid #39B54A",
                                  borderRadius: "5px",
                                  cursor: loading ? "not-allowed" : "pointer",
                                  whiteSpace: "nowrap",
                                  flexShrink: 0,
                                }}
                              >
                                <img
                                  src={Approved32}
                                  alt="Approve"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    flexShrink: 0,
                                  }}
                                />
      
                                {loading ? "Processing..." : "Approve Selected"}
                              </button>
      
                              {/* Reject */}
                              <button
                                onClick={() => rejectSendbackbeforecheckup(2)}
                                disabled={selectedBills.length <= 0 || loading}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px",
                                  margin: "12px 0",
                                  padding: "8px 10px",
                                  fontWeight: "600",
                                  backgroundColor:
                                    selectedBills.length <= 0 ? "#f3eeee" : "#C1272D",
                                  color: selectedBills.length > 0 ? "#ffffff" : "red",
                                  border: "1px solid #ff6b81",
                                  borderRadius: "8px",
                                  cursor:
                                    selectedBills.length <= 0 || loading
                                      ? "not-allowed"
                                      : "pointer",
                                  whiteSpace: "nowrap",
                                  flexShrink: 0,
                                }}
                              >
                                <img
                                  src={DeleteRed32}
                                  alt="Reject"
                                  style={{
                                    width: "18px",
                                    height: "18px",
                                    flexShrink: 0,
                                    filter:
                                      selectedBills.length > 0
                                        ? "brightness(0) invert(1)"
                                        : "none",
                                  }}
                                />
      
                                {loading ? "Processing..." : "Reject Selected"}
                              </button>
      
                              {/* Send Back */}
                              {isChecker && (
                                <button
                                  onClick={() => rejectSendbackbeforecheckup(3)}
                                  disabled={selectedBills.length <= 0 || loading}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "6px",
                                    margin: "12px 0",
                                    padding: "8px 10px",
                                    fontWeight: "600",
                                    backgroundColor:
                                      selectedBills.length <= 0
                                        ? "#f3eeee"
                                        : "#0d6efd",
                                    color:
                                      selectedBills.length > 0
                                        ? "#ffffff"
                                        : "#0d6efd",
                                    border: "1px solid #0d6efd",
                                    borderRadius: "8px",
                                    cursor:
                                      selectedBills.length <= 0 || loading
                                        ? "not-allowed"
                                        : "pointer",
                                    whiteSpace: "nowrap",
                                    flexShrink: 0,
                                  }}
                                >
                                  <img
                                    src={SendBack32}
                                    alt="Send Back"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      flexShrink: 0,
                                      opacity: selectedBills.length > 0 ? 1 : 0.8,
                                      filter:
                                        selectedBills.length > 0
                                          ? "brightness(0) invert(1)"
                                          : "none",
                                      filter:
                                        selectedBills.length > 0
                                          ? "brightness(0) invert(1)"
                                          : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
                                    }}
                                  />
      
                                  {loading ? "Processing..." : "Send Back Selected"}
                                </button>
                              )}
                            </div>
      
                            {/* ---- Pagination ---- */}
      
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: "20px",
                                // padding: "0 10px",
                              }}
                            >
                              {/* Showing Entries */}
      
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "13px",
                                  color: "black",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Showing{" "}
                                {filteredBills?.length === 0
                                  ? 0
                                  : indexOfFirstBill + 1}{" "}
                                to {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                                of {filteredBills?.length} entries
                              </p>
      
                              {/* Pagination */}
      
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "18px",
                                }}
                              >
                                {/* Previous */}
      
                                <button
                                  type="button"
                                  onClick={() =>
                                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                                  }
                                  disabled={currentPage === 1}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    color: "#2ea4e7",
                                    cursor:
                                      currentPage === 1 ? "not-allowed" : "pointer",
                                    fontSize: "13px",
                                    padding: 0,
                                    opacity: currentPage === 1 ? 0.5 : 1,
                                  }}
                                >
                                  ‹ Previous
                                </button>
      
                                {/* Page Numbers */}
      
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "20px",
                                  }}
                                >
                                  {getPageNumbers().map((page, index) => {
                                    if (page === "...") {
                                      return (
                                        <span
                                          key={`dots-${index}`}
                                          style={{
                                            color: "#444",
                                            fontSize: "13px",
                                          }}
                                        >
                                          ...
                                        </span>
                                      );
                                    }
      
                                    return (
                                      <button
                                        type="button"
                                        key={page}
                                        onClick={() => setCurrentPage(page)}
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                          padding: 0,
                                          color:
                                            currentPage === page ? "#2ea4e7" : "#444",
                                          cursor: "pointer",
                                          fontSize: "13px",
                                          fontWeight:
                                            currentPage === page ? "600" : "400",
                                          textDecoration:
                                            currentPage === page
                                              ? "underline"
                                              : "none",
                                        }}
                                      >
                                        {page}
                                      </button>
                                    );
                                  })}
                                </div>
      
                                {/* Next */}
      
                                <button
                                  type="button"
                                  onClick={() =>
                                    setCurrentPage((prev) =>
                                      Math.min(prev + 1, totalPages),
                                    )
                                  }
                                  disabled={
                                    currentPage === totalPages || totalPages === 0
                                  }
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                    color: "#2ea4e7",
                                    cursor:
                                      currentPage === totalPages || totalPages === 0
                                        ? "not-allowed"
                                        : "pointer",
                                    fontSize: "13px",
                                    padding: 0,
                                    opacity:
                                      currentPage === totalPages || totalPages === 0
                                        ? 0.5
                                        : 1,
                                  }}
                                >
                                  Next ›
                                </button>
                              </div>
                            </div>
                          </>
                        {/* )} */}
                        </div>
                      </div>
                      {rejectPanelhide === 2 && (
                        <div
                          className="col-12 RejectPanelContainer"
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "rgba(0, 0, 0, 0.35)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999,
                          }}
                        >
                          <div
                            className="Rejectpanel"
                            style={{
                              width: "500px",
                              background: "#fff",
                              borderRadius: "10px",
                              padding: "20px",
                              boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                            }}
                          >
                            <form action="">
                              <div className="col-12 elements">
                                <div className="row">
                                  <div className="col-3">
                                    <label className="fw-bold">
                                      Remark <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <textarea
                                      name=""
                                      id=""
                                      placeholder="Enter Remark"
                                      value={remark}
                                      onChange={(e) => setRemark(e.target.value)}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </form>
                            <div className="col-12 ms-auto my-4">
                              <div className="row">
                                {/* <div className="col-3"></div> */}
                                <div className="col-9 m-auto">
                                  <div
                                    className="col-12"
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <button
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "4px",
                                        background:
                                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                        width: "5rem",
                                        height: "2rem",
                                        fontSize: "18px",
                                      }}
                                      onClick={() => approveSelected("Rejected")}
                                    >
                                      {" "}
                                      Reject
                                    </button>
                                    <button
                                      type="button"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "4px",
                                        backgroundColor: "#f1594c",
                                        width: "6rem",
                                        height: "2rem",
                                        fontSize: "16px",
                                      }}
                                      onClick={() => window.location.reload()}
                                    >
                                      {" "}
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {rejectPanelhide === 3 && (
                        <div
                          className="col-12 RejectPanelContainer"
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "rgba(0, 0, 0, 0.35)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 9999,
                          }}
                        >
                          <div
                            className="Rejectpanel"
                            style={{
                              width: "500px",
                              background: "#fff",
                              borderRadius: "10px",
                              padding: "20px",
                              boxShadow: "0 0 15px rgba(0,0,0,0.2)",
                            }}
                          >
                            <form action="">
                              <div className="col-12 elements">
                                <div className="row">
                                  <div className="col-3">
                                    <label className="fw-bold">
                                      Remark <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="col-8">
                                    <textarea
                                      name=""
                                      id=""
                                      placeholder="Enter Remark"
                                      onChange={(e) => setRemark(e.target.value)}
                                    ></textarea>
                                  </div>
                                </div>
                              </div>
                            </form>
                            <div className="col-12 ms-auto my-4">
                              <div className="row">
                                {/* <div className="col-3"></div> */}
                                <div className="col-9 m-auto">
                                  <div
                                    className="col-12"
                                    style={{
                                      display: "flex",
                                      gap: "10px",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <button
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "4px",
                                        background:
                                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                        width: "8rem",
                                        height: "2rem",
                                        fontSize: "18px",
                                      }}
                                      onClick={() =>
                                        approveSelected("SendBack", remark)
                                      }
                                    >
                                      Send Back
                                    </button>
                                    <button
                                      type="button"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "4px",
                                        backgroundColor: "#f1594c",
                                        width: "6rem",
                                        height: "2rem",
                                        fontSize: "16px",
                                      }}
                                      onClick={() => window.location.reload()}
                                    >
                                      {" "}
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {showspecific === 3 && (
                    <>
                    {/* 14-10 for dynmaic scrolling */}
                    <style>{`
        .billslip-scroll {
        width: 100%;
        max-height: calc(100vh - 240px);
        overflow-y: auto;
        overflow-x: auto;
        scrollbar-width: thin;
        scrollbar-color: #8b98a8 #e8edf3;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
        box-sizing: border-box;
      }
      
      .billslip-scroll::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      
      .billslip-scroll::-webkit-scrollbar-track {
        background: #e8edf3;
        border-radius: 8px;
      }
      
      .billslip-scroll::-webkit-scrollbar-thumb {
        background: #8b98a8;
        border-radius: 8px;
      }
      
      .billslip-scroll::-webkit-scrollbar-thumb:hover {
        background: #596a80;
      }
      `}</style>
                      <div className="col-12 m-auto" >
                        {/* //30/10 */}
                       <div
        className="col-12 m-auto my-5 budgetContainer"
        style={{
          border: "1px solid #d5dce5",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.12)",
          backgroundColor: "#eef2f8",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
                          <div
                            className=" d-flex justify-content-between"
                            style={{
                              position: "relative",
                              alignItems: "center",
                              //30/10
                              // background: "#fff",
                            }}
                          >
                            {/* TITLE – LEFT */}
                            <div
                              className="d-flex align-items-center gap-2 mb-3"
                              style={{ paddingLeft: "150px" }}
                            >
                               <img src="/Bill-Generation-32.png" alt=""  width="26" height="26"  />
       
                              <h5 className="m-0 fw-bold">Bill Slip</h5>
                            </div>
                            {/* BACK BUTTON – TOP RIGHT */}
                            <div
                              className="col-4 pb-3 d-flex justify-content-end gap-2"
                              style={{ paddingRight: "140px" }}
                            >
                              <button
                                className="btn btn-primary d-flex align-items-center gap-2"
                                style={{
                                  width: "110px",
                                  // borderRadius: "30px",
                                  // padding: "6px 6px",
                                  fontSize: "12px",
                                  zIndex: 10,
                                  textAlign: "center",
      
                                  // border:"1px solid black"
                                }}
                                onClick={exportBillSlipPDF}
                                disabled={exportingBillSlipPDF}
                              >
                                {" "}
                                {exportingBillSlipPDF
                                  ? "Downloading..."
                                  : "Download PDF"}
                              </button>
                              <button
                                className="btn btn-danger d-flex align-items-center gap-2"
                                style={{
                                  top: "12px",
                                  right: "12px",
                                  // borderRadius: "999px",
                                  padding: "6px 15px",
                                  fontSize: "12px",
                                  zIndex: 10,
                                }}
                                onClick={BackFunction}
                              >
                                {" "}
                                Back{" "}
                              </button>
                            </div>
                          </div>
                          {/* 14-10 for dynamic scrolling */}
                          <div className="m-auto budgetElement billslip-scroll">
                            {/* Heading */}
      
                            {/* TABLE CONTAINER */}
      
                           
                          
                            <div ref={billSlipRef}>
                              {/* Table Header */}
      
                               <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "13px",
          fontWeight: 600,
          padding: "6px 4px",
          borderBottom: "1px solid #BFC5CC",
        }}
      >
        <span>
          UserName : {fetchSpecificDemandDeductionDetail?.[0]?.CreatedByName || "-"}
        </span>
        <span>
          Date : {formatSlipDate(
            fetchSpecificDemandDeductionDetail?.[0]?.UploadedOn || selectedBillData?.UploadedOn
          )}
        </span>
      </div>
                              <div
                                className="text-center text-white py-3"
                                style={{
                                  background:
                                    "linear-gradient(90deg, #2b4ea1, #0aa2d6)",
                                }}
                              >
                                <h5 className="mb-1 fw-bold">
                                  Liability Register System
                                </h5>
                                <div className="fw-semibold">
                                  {" "}
                                  (Maharashtra urban development department){" "}
                                </div>
                                <div className="fw-bold mt-1">
                                  Payment Authority Year 2026-27
                                </div>
                                <div className="fw-bold mt-1">
                                  {" "}
                                  Agency - {selectedBillData?.PIU || "-"}{" "}
                                </div>
                              </div>
                              {/* Body */}
                              <div className="border  p-1">
                                {/* //29/10 */}
                                <div className="bs-table-wrapper">
                                <table className="bs-grid"
                                  // className="table mb-0"
                                 style={{
        fontSize: "14px",
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #1190CA"
      }}
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        colSpan={2}
                                        className="fw-bold text-center fs-6 p-1"
                                      >
                                        {" "}
                                        Bill Slip for LRS
                                      </td>
                                    </tr>
                                    {/* //29/10 */}
                                {[
        [
          "Transaction Number",
          `${selectedBillData?.BillNumber || selectedDemandID}`,
        ],
        [
          "Date",
          selectedBillData?.Date
            ? new Date(selectedBillData.Date).toLocaleDateString()
            : "-",
        ],
        ["Designation", selectedBillData?.Designation || "-"],
        ["Project Name", selectedBillData?.ProjectName || "-"],
        ["Agency Name", selectedBillData?.Agency_Name || "-"],
        ["Work Name", selectedBillData?.WorkName || "-"],
        ["RA Bill", selectedBillData?.RABillNumber || "-"],
      
        // Add these rows in the same table
        [
          "Total Bill Amount",
          selectedBillData?.BillAmount ?? "-",
        ],
          [
        "Bill Amount in Words",
        selectedBillData?.BillAmountInWords ??
          numberToWords(selectedBillData?.BillAmount),
      ],
        [
          "Net Payable",
          selectedBillData?.NetPayableAmount ?? "-",
        ],
        [
          "Deduction",
          selectedBillData?.DeductionAmount ?? "-",
        ],
      
      ].map(([label, value], index) => (
        <tr key={index} style={{ border: "1.5px solid #1190CA" }}>
          <td
            className="text-start"
            style={{
              width: "30%",
              backgroundColor: "#EAF3FB",
              fontWeight: 500,
              padding: "6px 10px",
              borderRight: "1.5px solid #1190CA",
            }}
          >
            {label}
          </td>
          <td
            className="text-start"
            style={{
              width: "70%",
              padding: "6px 10px",
              backgroundColor: "#FFFFFF",
            }}
          >
            {value}
          </td>
        </tr>
      ))}
                                  </tbody>
                                </table>
                                </div>
                                {/* //29/10 */}
                                {/* <table  className="bs-grid"
                                  // className="mt-1"
                                  style={{
                                    borderCollapse: "collapse",
                                    border: "1px solid #000",
                                    width: "100%",
                                  }}
                                >
                                  <tbody>
                                    <tr className="border border-dark">
                                      <td
                                        className="text-start border border-dark "
                                        style={{ width: "30%" }}
                                      >
                                        {" "}
                                        Total Bill Amount
                                      </td>
                                      <td
                                        className="text-start border border-dark"
                                        style={{ width: "23%" }}
                                      >
                                        Net Payable
                                      </td>
                                      <td
                                        className="text-start border border-dark"
                                        style={{ width: "23%" }}
                                      >
                                        {" "}
                                        Deduction
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-start border border-dark">
                                        {selectedBillData?.BillAmount}{" "}
                                      </td>
                                      <td className="text-start border border-dark">
                                        {" "}
                                        {selectedBillData?.NetPayableAmount}{" "}
                                      </td>
                                      <td className="text-start border border-dark">
                                        {selectedBillData?.DeductionAmount}{" "}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table> */}
      
                                {/* Vendor Details */}
                                {/* //29/10 */}
                                <div className="bs-table-wrapper">
                                <table  className="bs-grid"
                                  // className="mt-2"
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    fontSize: "14px",
                                  }}
                                >
                                  <tbody>
                                    {/* Section Title */}
                                    <tr
                                     style={{
                                        border: "1.5px solid #1190CA",
                                        backgroundColor: "#2f7bbd",
                                      }}
                                    >
                                      <td
                                        colSpan="6"
                                        style={{
                                          padding: "8px 10px",
                                          fontWeight: 600,
                                          textAlign: "center",
                                          color:"white"
                                        }}
                                      >
                                        {" "}
                                        Vendor Details
                                      </td>
                                    </tr>
      
                                    {/* Column Headers */}
                                    <tr style={{ border: "1.5px solid #1190CA" }}>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          fontWeight: 500,
                                          backgroundColor: "#1190CA",
                                          color: "white",
                                        }}
                                      >
                                        {" "}
                                        Vendor Name
                                      </td>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          fontWeight: 500,
                                          backgroundColor: "#1190CA",
                                          color: "white",
                                        }}
                                      >
                                        IFSC Code
                                      </td>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          fontWeight: 500,
                                          backgroundColor: "#1190CA",
                                          color: "white",
                                        }}
                                      >
                                        {" "}
                                        Branch Name{" "}
                                      </td>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          fontWeight: 500,
                                          backgroundColor: "#1190CA",
                                          color: "white",
                                        }}
                                      >
                                        {" "}
                                        Account Number
                                      </td>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          fontWeight: 500,
                                          backgroundColor: "#1190CA",
                                          color: "white",
                                        }}
                                      >
                                        {" "}
                                        Amount{" "}
                                      </td>
                                    </tr>
                                    {fetchSpecificDemandDeductionDetail &&
                                      fetchSpecificDemandDeductionDetail
                                        .filter(
                                          (val) =>
                                            val.TypeOfAmount ==
                                            "Total Amount Payable",
                                        )
                                        .map((val, index) => {
                                          return (
                                            <>
                                              <tr
                                                style={{
                                                  border: "1.5px solid #1190CA",
                                                }}
                                                key={index}
                                              >
                                                <td
                                                  style={{
                                                    padding: "6px 8px",
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  {val.Vendor_Company_Name}
                                                </td>
                                                <td
                                                  style={{
                                                    padding: "6px 8px",
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  {" "}
                                                  {val.Bank_IFSC_Code}{" "}
                                                </td>
                                                <td
                                                  style={{
                                                    padding: "6px 8px",
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  {val.Branch_Name}
                                                </td>
                                                <td
                                                  style={{
                                                    padding: "6px 8px",
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  {" "}
                                                  {val.Bank_Account_Number}
                                                </td>
                                                <td
                                                  style={{
                                                    padding: "6px 8px",
                                                    backgroundColor: "white",
                                                  }}
                                                >
                                                  {val.TotalAmount}
                                                </td>
                                              </tr>
                                            </>
                                          );
                                        })}
                                    {/* <tr style={{ border: "1.5px solid #1190CA" }}>
                                <td
                                >
                                  Shivsai Construction
                                </td>
                                <td className='border border-dark'>AKIPS8199N</td>
                                <td className='border border-dark'>MAHB0001302</td>
                                <td className='border border-dark'>BANK OF MAHARASHTRA, GHODBUNDER ROAD</td>
                                <td className='border border-dark'>2,43,991.0</td>
                                <td className='border border-dark'> 2,43,991.0</td>
                              </tr> */}
      
                                    {/* Total */}
                                    <tr style={{ border: "1.5px solid #1190CA" }}>
                                      <td
                                        style={{
                                          padding: "6px 8px",
                                          backgroundColor: "#EAF3FB",
                                          fontWeight: 500,
                                        }}
                                        colSpan={4}
                                      >
                                        {" "}
                                        Total
                                      </td>
                                      <td className="border border-dark">
                                        {selectedBillData?.NetPayableAmount}{" "}
                                      </td>
                                    </tr>
                                  </tbody>
                       
                                </table>
                                </div>
                                {/* //29/10 */}
                                <div className="bs-table-wrapper">
                                <table  className="bs-grid"
                                  // className="my-2"
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        border: "1.5px solid #1190CA",
                                        backgroundColor: "#2f7bbd",
                                      }}
                                    >
                                      <td
                                        colSpan="6"
                                        style={{
                                          padding: "8px 10px",
                                          fontWeight: 600,
                                          textAlign: "center",
                                          color: "white",
                                        }}
                                      >
                                        {" "}
                                        Deduction Amount Details
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        color: "white",
                                        backgroundColor: "#2f7bbd",
                                        height: "3rem",
                                      }}
                                    >
                                      <th
                                        style={{ minWidth: "60px", padding: "8px" }}
                                      >
                                        {" "}
                                        Sr No{" "}
                                      </th>
                                      <th
                                        style={{ minWidth: "60px", padding: "8px" }}
                                      >
                                        {" "}
                                        Deduction Type{" "}
                                      </th>
                                      <th
                                        style={{ minWidth: "60px", padding: "8px" }}
                                      >
                                        {" "}
                                        Deduction Amount{" "}
                                      </th>
                                      <th
                                        style={{ minWidth: "60px", padding: "8px" }}
                                      >
                                        {" "}
                                        Amount Number
                                      </th>
                                      <th
                                        style={{ minWidth: "60px", padding: "8px" }}
                                      >
                                        {" "}
                                        IFSC{" "}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {fetchSpecificDemandDeductionDetail.filter(
                                      (val) =>
                                        val.TypeOfAmount != "Total Amount Payable",
                                    )?.length == 0 ? (
                                      <tr>
                                        <td
                                          colSpan="30"
                                          style={{
                                            textAlign: "center",
                                            padding: "20px",
                                            backgroundColor: "#f9f9f9",
                                          }}
                                        >
                                          {" "}
                                          No data available
                                        </td>
                                      </tr>
                                    ) : (
                                      fetchSpecificDemandDeductionDetail
                                        .filter(
                                          (val) =>
                                            val.TypeOfAmount !=
                                            "Total Amount Payable",
                                        )
                                        .map((technicalInwards, index) => {
                                          const bgColor =
                                            index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                          return (
                                            <tr
                                              className="px-3"
                                              key={index}
                                              style={{
                                                borderBottom: "1px solid #3b409e",
                                                backgroundColor: bgColor,
                                              }}
                                            >
                                              <td
                                                style={{
                                                  fontSize: "12px",
                                                  padding: "5px",
                                                }}
                                              >
                                                {index + 1}
                                              </td>
                                              <td
                                                style={{
                                                  fontSize: "12px",
                                                  padding: "5px",
                                                }}
                                              >
                                                {" "}
                                                {technicalInwards.TypeOfAmount}{" "}
                                              </td>
                                              <td
                                                style={{
                                                  fontSize: "12px",
                                                  padding: "5px",
                                                }}
                                              >
                                                {" "}
                                                {technicalInwards.TotalAmount}
                                              </td>
                                              <td
                                                style={{
                                                  fontSize: "12px",
                                                  padding: "5px",
                                                }}
                                              >
                                                {" "}
                                                {technicalInwards.Bank_Account_Number}
                                              </td>
                                              <td
                                                style={{
                                                  fontSize: "12px",
                                                  padding: "5px",
                                                }}
                                              >
                                                {technicalInwards.Bank_IFSC_Code}
                                              </td>
                                            </tr>
                                          );
                                        })
                                    )}
                                    <tr
                                      style={{
                                        border: "1.5px solid #1190CA",
                                        fontWeight: 600,
                                        background: "white",
                                      }}
                                    >
                                      <td
                                        colSpan="2"
                                        style={{
                                          padding: "6px 8px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {" "}
                                        Total
                                      </td>
                                      <td style={{ padding: "6px 8px" }}>
                                        {/* {selectedBillData?.DeductionAmount} */}
                                        {Math.round(
                                          Number(
                                            selectedBillData?.DeductionAmount || 0,
                                          ),
                                        )}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
      
      
                                </div>
      
                           {/* //29/10 */}     
                              {/* Bill Copy link */}
      {selectedBillData?.UploadBillCopy && (
        <div
          style={{
            width: "100%",
            boxSizing: "border-box",
            marginTop: "8px",
            border: "1px solid #000",
          }}
        >
          <table
            style={{
              width: "100%",
              tableLayout: "fixed",
              borderCollapse: "collapse",
              margin: 0,
              border: "none",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    backgroundColor: "#EAF1FB",
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "8px",
                    border: "none",
                  }}
                >
                  <a
                    href={`${apiurl}/BillCopyDocsImages/${encodeURIComponent(
                      selectedBillData.UploadBillCopy.trim()
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      display: "inline-block",
                      color: "black",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontWeight: 600,
                    }}
                  >
                    Bill Copy ↗
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
                                {/* Signature grid */}
                                {/* <table style={{ width: "100%" }}>
                                  <tbody>
                                    {[
                                      [
                                        {
                                          role: "MAKER",
                                          rDate: fetchSpecificDemandDeductionDetail[0]
                                            ?.UploadedOn
                                            ? fetchSpecificDemandDeductionDetail[0].UploadedOn.split(
                                                "T",
                                              )[0]
                                            : "-",
                                          aDate: fetchSpecificDemandDeductionDetail[0]
                                            ?.GM_Approval_Date
                                            ? fetchSpecificDemandDeductionDetail[0].GM_Approval_Date.split(
                                                "T",
                                              )[0]
                                            : "-",
                                        },
                                        {
                                          role: "Checker",
                                          rDate: fetchSpecificDemandDeductionDetail[0]
                                            ?.GM_Approval_Date
                                            ? fetchSpecificDemandDeductionDetail[0].GM_Approval_Date.split(
                                                "T",
                                              )[0]
                                            : "-",
                                          aDate: fetchSpecificDemandDeductionDetail[0]
                                            ?.Acnt_Approval_Date
                                            ? fetchSpecificDemandDeductionDetail[0].Acnt_Approval_Date.split(
                                                "T",
                                              )[0]
                                            : "-",
                                        },
                                      ],
                                    ].map((row, rowIndex) => (
                                      <div
                                        key={rowIndex}
                                        className="card d-flex flex-row "
                                      >
                                        {row.map((cell, colIndex) => (
                                          <div
                                            className="col-6 text-start mt-5 px-5 mb-2"
                                            key={colIndex}
                                          >
                                            <div>
                                              <strong>Signature :</strong>
                                            </div>
                                            <div>Received Date : {cell.rDate}</div>
                                            <div>Approved Date : {cell.aDate}</div>
                                            <div>Designation : {cell.role}</div>
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </tbody>
                                </table> */}
                                {/* //29/10 */}
                                  <table  className="bs-grid"
                                  style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    marginTop: "25px",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <tbody style={{}}>
                                    {Array.from({
                                      length: Math.ceil(signatureData.length / 3),
                                    }).map((_, rowIndex) => (
                                      <tr key={rowIndex}>
                                        {signatureData
                                          .slice(rowIndex * 3, rowIndex * 3 + 3)
                                          .map((item, index) => (
                                            <td
                                              key={index}
                                              style={{
                                                //border: "3px solid black",
                                                boxShadow:
                                                  "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px",
                                                width: "33.33%",
                                                height: "95px",
                                                background: "#f4f8fd",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                                padding: "8px",
                                                fontFamily: "Times New Roman",
                                                lineHeight: "1.3",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "14px",
                                                  marginBottom: "18px",
                                                }}
                                              >
                                                {" "}
                                                Signature :
                                              </div>
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  marginBottom: "5px",
                                                  color: "#424141",
                                                }}
                                              >
                                                {item.label} : {item.date}{" "}
                                              </div>
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  color: "#393838",
                                                }}
                                              >
                                                {" "}
       
                                                UserName :{item?.FullName || "-"}
                                              </div>
       
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  color: "#393838",
                                                }}
                                              >
                                                {" "}
                                                Designation : {item.designation}
                                              </div>
                                            </td>
                                          ))}
       
                                        {rowIndex ===
                                          Math.ceil(signatureData.length / 3) - 1 &&
                                          signatureData.length % 3 !== 0 &&
                                          Array.from({
                                            length: 3 - (signatureData.length % 3),
                                          }).map((_, i) => (
                                            <td
                                              key={`empty-${i}`}
                                              style={{
                                                border: "2px solid #000",
                                                width: "33.33%",
                                                height: "145px",
                                                backgroundColor: "#eef2f7",
                                              }}
                                            ></td>
                                          ))}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
       
      
                                {/* Footer */}
                                <div
                                  className="row g-0"
                                  style={{
                                    borderTop: "1.5px solid #1190CA",
                                    minHeight: "120px",
                                    padding: "20px 0",
                                  }}
                                >
                                  <div
                                    className="col-2 d-flex flex-column justify-content-center"
                                    style={{ alignItems: "flex-start" }}
                                  >
                                    <div
                                      style={{
                                        width: "130px",
                                        height: "130px",
                                        border: "1px solid #BFC5CC",
                                        padding: "4px",
                                        backgroundColor: "#fff",
                                      }}
                                    >
                                      <img
                                        src="/sample-qr-code.png"
                                        alt="Bill QR Code"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "6px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {" "}
                                      Bill QR Code
                                    </div>
                                  </div>
                                  {/* Center text – TOP aligned */}
                                  <div
                                    className="col-8 px-3"
                                    style={{
                                      fontSize: "13px",
                                      color: "#333",
                                      lineHeight: "1.4",
                                      fontWeight: "500",
                                      textAlign: "justify",
                                      alignSelf: "flex-start",
                                      marginTop: "10px",
                                    }}
                                  ></div>
                                  {/* Work QR - RIGHT EDGE */}
                                  <div
                                    className="col-2 d-flex flex-column justify-content-center"
                                    style={{ alignItems: "flex-end" }}
                                  >
                                    <div
                                      style={{
                                        width: "130px",
                                        height: "130px",
                                        border: "1px solid #BFC5CC",
                                        padding: "4px",
                                        backgroundColor: "#fff",
                                      }}
                                    >
                                      <img
                                        src="/sample-qr-code.png"
                                        alt="Work QR Code"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          objectFit: "contain",
                                        }}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "6px",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Work QR Code{" "}
                                    </div>
                                  </div>
                                </div>
      
                                {/* //29/10 */}
                                <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "10px 4px",
          fontSize: "12px",
          fontWeight: 600,
          color: "#000",
          borderTop: "1px solid #BFC5CC",
          whiteSpace:"nowrap"
        }}
      >
        Print Date: {getPrintDate()}
      </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
              </div>
              </>
            ) : (
              <DemandGeneration
                isEdit={true}
                billData={editBillData}
                onSuccess={() => {
                  setShowEditForm(false);
                  getbills();
      
                  setSelectedBills([]);
                }}
                onCancel={() => {
                  setShowEditForm(false);
                }}
              />
            )}
          </>
        );
      };

export default BillApprovals;
